'use client'

import { useTranslations } from '@/lib/next-shim'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

import { AddressDetailsForm, type AddressDetails } from '@/shared/ui/address/AddressDetailsForm'

type AccessDetailsCollapsibleProps = {
  open: boolean
  onToggle: () => void
  value: AddressDetails
  onChange: (details: AddressDetails) => void
}

export function AccessDetailsCollapsible({ open, onToggle, value, onChange }: AccessDetailsCollapsibleProps) {
  const t = useTranslations('address')

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      <button type="button" onClick={onToggle} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100">
        <span className="text-sm font-medium text-gray-700">{t('accessDetails')}</span>
        {open ? <ChevronUpIcon className="h-4 w-4 text-gray-500" /> : <ChevronDownIcon className="h-4 w-4 text-gray-500" />}
      </button>
      {open && (
        <div className="px-4 py-3">
          <AddressDetailsForm value={value} onChange={onChange} />
        </div>
      )}
    </div>
  )
}
